import styled from 'styled-components';
import { ScreenScrapeButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeButton';
import {
  getRedirectUrlForProcess,
  handleRedirect,
} from 'src/common/services/process';
import { useEffect, useState } from 'react';
import { Loader } from 'src/common/components/Loader';
import { ScreenScrapeStepTitle } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeStepTitle';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { verificationIdParam } from 'src/routes';
import { MessageError } from 'src/common/models/message';
import { ToastWrapper } from 'src/common/components/Toast';
import { toast } from 'react-toastify';
import { toastOptions } from 'src/common/components/Toast/config';

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledButton = styled(ScreenScrapeButton)`
  margin-top: auto;
`;

const Text = styled.p`
  text-align: center;
  margin-bottom: 0.5rem;
`;

const Paragraph = styled.p`
  text-align: center;
`;

const SeesionTimeoutToast: React.FC = () => (
  <ToastWrapper kind="error">
    <Paragraph>
      Sesja autoryzacji z bankiem wygasła, aby przejść dalej wybierz ponownie
      bank.
    </Paragraph>
  </ToastWrapper>
);

export const ScreenScrapeError = () => {
  const verificationId = localStorage.getItem(verificationIdParam);
  const [isLoading, setIsLoading] = useState(false);
  const { lastJsonMessage, closeModal } = useSSContext();

  const redirect = () => {
    if (verificationId) {
      setIsLoading(true);
      getRedirectUrlForProcess(verificationId)
        .then(({ redirectUrl }) => {
          handleRedirect(redirectUrl);
        })
        .finally(() => setIsLoading(false));
    } else {
      console.error('No verificationId');
    }
  };

  const messageError = lastJsonMessage?.object as MessageError | null;

  useEffect(() => {
    if (messageError?.source === 'USER') {
      toast(<SeesionTimeoutToast />, {
        ...toastOptions,
        toastId: 'session-timeout',
      });
      return closeModal();
    }

    const timeout = setTimeout(() => {
      redirect();
    }, 4000);

    return () => timeout && clearTimeout(timeout);
  }, []);

  return (
    <>
      <ScreenScrapeStepTitle>Wystąpił błąd</ScreenScrapeStepTitle>
      <Container>
        <Text>
          {messageError?.exceptionDetails ||
            'Nie udało się potwierdzić tożsamości.'}
        </Text>
        <Text>Zostaniesz przeniesiony na stronę partnera.</Text>
        <StyledButton onClick={redirect}>
          {!isLoading ? 'Dalej' : <Loader width={15} height={15} />}
        </StyledButton>
      </Container>
    </>
  );
};
